import { render } from "./ProfileSelector.vue?vue&type=template&id=1979b434"
import script from "./ProfileSelector.vue?vue&type=script&lang=js"
export * from "./ProfileSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__